module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('topnav', {
    attrs: {
      "keywords": _vm.keyword,
      "toptype": _vm.toptype,
      "isSearch": _vm.path
    },
    on: {
      "tosearch": _vm.tosearch
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "min-height": "600px"
    }
  }, [(_vm.config) ? _c('div', {}, [_c('el-image', {
    staticClass: "topimg",
    attrs: {
      "src": _vm._f("addurl")(_vm.config.rzqy_pic),
      "fit": "fill"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "response bggray"
  }, [_c('div', {
    staticClass: "marginauto comswidth"
  }, [_c('div', {
    staticClass: "bg-white topall flex justify-between align-center"
  }, [_c('div', {
    staticClass: "flex justify-start align-center imgall"
  }, [_c('el-image', {
    staticClass: "topsimg",
    attrs: {
      "src": "/static/assets/images/com.png",
      "fit": "fill"
    }
  })], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "330px"
    }
  }, [_c('div', {
    staticClass: "topbtn pointer",
    on: {
      "click": _vm.tonext
    }
  }, [_vm._v("立即申请")])])]), _vm._v(" "), _c('div', {
    staticClass: "margin-top flex animated slideInLeft flex-wrap align-center justify-start"
  }, _vm._l((_vm.list), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "bg-white marone hvr-float martwo"
    }, [_c('div', {
      staticClass: "flex"
    }, [_c('div', {
      staticClass: "flex align-center",
      staticStyle: {
        "width": "90px",
        "height": "90px"
      }
    }, [_c('el-image', {
      staticStyle: {
        "width": "90px",
        "height": "90px"
      },
      attrs: {
        "src": _vm._f("addurl")(item.shop_logo),
        "fit": "cover"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticStyle: {
        "padding-left": "15px",
        "height": "90px",
        "padding-top": "10px",
        "width": "70%"
      }
    }, [_c('div', {
      staticClass: "text-cut",
      staticStyle: {
        "color": "#262626",
        "font-size": "21px",
        "margin-bottom": "15px"
      }
    }, [_vm._v(_vm._s(item.shop_name))]), _vm._v(" "), _c('div', {
      staticClass: "text-cut response",
      staticStyle: {
        "color": "#9c9c9c",
        "font-size": "20px"
      }
    }, [_vm._v(_vm._s(item.add_detail))])])]), _vm._v(" "), _c('div', {
      staticClass: "flex justify-between align-center margin-top"
    }, [_c('div', {
      staticStyle: {
        "color": "#1b1b1b",
        "font-size": "18px"
      }
    }, [_vm._v("\n                                浏览 "), _c('span', {
      staticStyle: {
        "color": "#ff9703"
      }
    }, [_vm._v(_vm._s(item.see_number))])]), _vm._v(" "), _c('div', {
      staticClass: "dbtn pointer",
      on: {
        "click": function($event) {
          return _vm.todetail(item.id)
        }
      }
    }, [_vm._v("\n                                详情\n                            ")])])])
  }), 0), _vm._v(" "), (_vm.list.length) ? _c('div', {
    staticClass: "flex justify-center ",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('div', {
    staticClass: "topbtn pointer",
    on: {
      "click": _vm.tolist
    }
  }, [_vm._v("查看更多")])]) : _vm._e(), _vm._v(" "), (!_vm.list.length) ? _c('div', [_c('el-empty', {
    attrs: {
      "description": "暂无数据"
    }
  })], 1) : _vm._e()])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex-sub pointer"
  }, [_c('div', {
    staticClass: "toptitle",
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_vm._v("企业入驻申请")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e5207842"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/company.vue
// module id = 423
// module chunks = 1